import {
  convertFahrenheitToUserPreference,
  getUnit,
} from "~/helpers/userPreference";
import {
  TEMP_MAX_GREEN_LIMIT,
  TEMP_MAX_YELLOW_LIMIT,
} from "../constants/thermal";
import { UNITS } from "~/constants/unit";

export const calculateColorMaxTempValue = (temp: number) => {
  const unit = getUnit(UNITS.CELSIUS);

  if (temp < TEMP_MAX_GREEN_LIMIT) {
    return {
      color: "green",
      title: `${convertFahrenheitToUserPreference(
        0,
      )}-${convertFahrenheitToUserPreference(700)}${unit}`,
    };
  } else if (temp < TEMP_MAX_YELLOW_LIMIT) {
    return {
      color: "yellow",
      title: `${convertFahrenheitToUserPreference(
        700,
      )}-${convertFahrenheitToUserPreference(850)}${unit}`,
    };
  } else {
    return {
      color: "red",
      title: `<${convertFahrenheitToUserPreference(850)}${unit}`,
    };
  }
};
